import { createReducer } from 'typesafe-actions'
import {
  ReadSfBankAccountsRequestDto,
  ReadSfBankAccountsResponseDto,
  ReadUserSfBankAccountResponseDto,
} from '@sparling/financial-common'
import { omit } from 'lodash'
import { ActionTypes } from '../types'
import { LoadingStateEnum } from '../../types'
import {
  getSfBankAccountsRequest,
  getSfBankAccountsSuccess,
  getSfBankAccountsFailure,
  getAssignedAccountsByUserRequest,
  getAssignedAccountsByUserSuccess,
  getAssignedAccountsByUserFailure,
  getAssignedAccountIdsByUserRequest,
  getAssignedAccountIdsByUserSuccess,
  resetSfBankAccountsFilters,
} from '../actions'

type AssignedUserAccounts = {
  idSf: string | null
  loading: LoadingStateEnum
  data: ReadUserSfBankAccountResponseDto
  assignedIds: number[]
  error: Error | null
}

export type SfBankAccountsState = {
  loading: LoadingStateEnum
  data: ReadSfBankAccountsResponseDto
  filters: ReadSfBankAccountsRequestDto
  error: Error | null
  assignedUserAccounts: AssignedUserAccounts
}

export const initialState = {
  loading: LoadingStateEnum.IDLE,
  data: {
    items: [],
    meta: {
      itemCount: 0,
      totalItems: 0,
      itemsPerPage: 0,
      totalPages: 0,
      currentPage: 0,
    },
  },
  filters: {},
  error: null,
  assignedUserAccounts: {
    idSf: null,
    loading: LoadingStateEnum.IDLE,
    data: {
      items: [],
      meta: {
        currentPage: 0,
        itemCount: 0,
        itemsPerPage: 0,
        totalItems: 0,
        totalPages: 0,
      },
    },
    assignedIds: [],
    error: null,
  },
}

export const sfBankAccounts = createReducer<SfBankAccountsState, ActionTypes>(initialState)
  .handleAction(getSfBankAccountsRequest, (state, { payload }) => ({
    ...state,
    filters: {
      ...state.filters,
      ...payload,
      page: Object.keys(omit(payload, 'page')).length > 0 ? 1 : payload.page,
    },
    loading: LoadingStateEnum.LOADING,
  }))
  .handleAction(getSfBankAccountsSuccess, (state, { payload }) => ({
    ...state,
    loading: LoadingStateEnum.SUCCESS,
    data: payload,
  }))
  .handleAction(getSfBankAccountsFailure, (state, { payload }) => ({
    ...state,
    loading: LoadingStateEnum.ERROR,
    error: payload,
  }))
  .handleAction(getAssignedAccountIdsByUserRequest, (state) => ({
    ...state,
    assignedUserAccounts: {
      ...state.assignedUserAccounts,
      assignedIds: [],
    },
  }))
  .handleAction(getAssignedAccountIdsByUserSuccess, (state, { payload }) => ({
    ...state,
    assignedUserAccounts: {
      ...state.assignedUserAccounts,
      assignedIds: payload,
    },
  }))
  .handleAction(getAssignedAccountsByUserRequest, (state, { payload: { idSf } }) => ({
    ...state,
    assignedUserAccounts: {
      idSf,
      loading: LoadingStateEnum.LOADING,
      data: initialState.assignedUserAccounts.data,
      assignedIds: initialState.assignedUserAccounts.assignedIds,
      error: null,
    },
  }))
  .handleAction(getAssignedAccountsByUserSuccess, (state, { payload }) => ({
    ...state,
    assignedUserAccounts: {
      ...state.assignedUserAccounts,
      loading: LoadingStateEnum.SUCCESS,
      data: payload,
    },
  }))
  .handleAction(getAssignedAccountsByUserFailure, (state, { payload }) => ({
    ...state,
    assignedUserAccounts: {
      ...state.assignedUserAccounts,
      loading: LoadingStateEnum.ERROR,
      error: payload,
    },
  }))
  .handleAction(resetSfBankAccountsFilters, (state) => ({
    ...state,
    filters: initialState.filters,
  }))
